import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { c as N } from "../index-rKuIKazb.js";
import y from "../BackgroundImageContainer/index.js";
import v from "../Card/index.js";
import C from "../Heading/index.js";
import k from "../LinkButton/index.js";
import x from "../FeatureBullets/index.js";
import D from "../ThemeText/index.js";
import { useTheme as b } from "../ThemeProvider/index.js";
import { s as B } from "../dashboard-BGZXQ42e.js";
import '../assets/index15.css';const z = "_layout_128fc_2", T = "_content_128fc_6", j = "_details_128fc_15", q = "_descriptionContainer_128fc_21", A = "_image_128fc_27", F = "_imageDefault_128fc_28", L = "_dark_128fc_37", w = "_description_128fc_21", a = {
  layout: z,
  content: T,
  details: j,
  descriptionContainer: q,
  image: A,
  imageDefault: F,
  dark: L,
  description: w
}, P = (i) => {
  const {
    className: r,
    cta: o,
    dataAaa: s = "buyNow",
    description: n,
    features: c = [],
    href: m,
    image: d,
    productName: l,
    productSlug: p,
    price: f,
    reverse: u
  } = i, _ = b(), g = N(a[_], a.layout, r), h = `- ${f}`;
  return /* @__PURE__ */ e(v, { className: g, children: /* @__PURE__ */ e(y, { reverse: u, size: "medium", children: /* @__PURE__ */ t("div", { className: a.content, children: [
    /* @__PURE__ */ t("div", { className: a.details, children: [
      /* @__PURE__ */ t(C, { size: "h3", children: [
        /* @__PURE__ */ e(D, { children: l }),
        " ",
        h
      ] }),
      /* @__PURE__ */ t("div", { className: a.descriptionContainer, children: [
        /* @__PURE__ */ e("div", { className: a.description, children: n }),
        /* @__PURE__ */ e(x, { features: c })
      ] }),
      /* @__PURE__ */ e(
        k,
        {
          "data-aaa": s,
          "data-product-slug": p,
          href: m,
          target: "_blank",
          rel: "noopener noreferrer",
          children: o
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: a.image, children: d || /* @__PURE__ */ e(
      "img",
      {
        className: a.imageDefault,
        alt: "Laptop displaying the Achievable exam prep dashboard and a smartphone displaying a quiz question",
        src: B
      }
    ) })
  ] }) }) });
};
export {
  P as default
};
